import React from "react";
import { Link } from "react-router-dom"; // Import Link for internal navigation
import '../Styles/Footer.css'; // Ensure this path is correct
import '@fortawesome/fontawesome-free/css/all.min.css';
import newFooterLogo from '../assets/images/edulablogo2footer.png';
import cycleIcon from '../assets/images/cycle_only_transparent.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={newFooterLogo} alt="Edulab Logo" />
          <div className="footer-address">
            <p>
              <i className="fas fa-map-marker-alt"></i>
              <strong>Address:</strong><br />
              13, Kondivita Rd, near Pidilite Industries,<br />
              Marol MIDC Industry Estate, Andheri East,<br />
              Mumbai, Maharashtra 400093
            </p>
            <p>
              <i className="fas fa-envelope"></i>
              <strong>Email:</strong><br />
              <a href="mailto:info@edulab.in">info@edulab.in</a>
            </p>
            <p>
              <i className="fas fa-phone"></i>
              <strong>Phone:</strong><br />
              <a href="tel:+912269432222">022-6943-2222</a>
            </p>
          </div>
          <button className="demo-button">
            Request a Demo <i className="fas fa-arrow-right"></i>
          </button>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h3><i className="fas fa-cube"></i> Products</h3>
            <ul>
              <li><Link to="/aboutus"><i className="fas fa-circle"></i> SFC solution</Link></li>
              <li><Link to="/aboutus"><i className="fas fa-circle"></i> Admission</Link></li>
              <li><Link to="/aboutus"><i className="fas fa-circle"></i> Exam LMS</Link></li>
              <li><Link to="/aboutus"><i className="fas fa-circle"></i> Marksheet</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3><i className="fas fa-building"></i> Company</h3>
            <ul>
              <li><Link to="/aboutpage"><i className="fas fa-circle"></i> About Us</Link></li>
              <li><Link to="/contact"><i className="fas fa-circle"></i> Contact Us</Link></li>
              <li><Link to="/news"><i className="fas fa-circle"></i> News</Link></li>
              <li><Link to="/career"><i className="fas fa-circle"></i> Career</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3><i className="fas fa-book"></i> Resources</h3>
            <ul>
              <li><a href="https://google.com"><i className="fas fa-circle"></i> Blog</a></li>
              <li><a href="https://google.com"><i className="fas fa-circle"></i> Tutorials</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3><i className="fas fa-gavel"></i> Legal</h3>
            <ul>
              <li><a href="https://google.com"><i className="fas fa-circle"></i> Terms & Conditions</a></li>
              <li><a href="https://google.com"><i className="fas fa-circle"></i> Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
      </div>

      <div className="footer-decoration"></div>

      <div className="footer-image">
        <img src={cycleIcon} alt="Bicycle" />
      </div>

      <div className="footer-bottom-right">
        <div className="social-icons">
          <a href="https://www.linkedin.com/company/edulab/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a href="https://www.facebook.com/edulab.in/" target="_blank" rel="noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/edulab.in/" target="_blank" rel="noreferrer" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/user/EdulabIndernship" target="_blank" rel="noreferrer" aria-label="YouTube">
            <i className="fab fa-youtube"></i>
          </a>
          <a href="https://x.com/edulab_india?lang=en" target="_blank" rel="noreferrer" aria-label="Twitter">
            <i className="fab fa-twitter"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
